export enum BreakType {
    SHORT_BREAK = "short_break",
    LUNCH = "food_break",
    PERSONAL = "personal_break",
    OTHER = "other"
}

